var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarlevelNonfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8076 7.94238C16.0989 8.57389 16.6971 9.00881 17.3877 9.09082L24.0439 9.87988L19.123 14.4307C18.6124 14.9029 18.384 15.6069 18.5195 16.2891L19.8252 22.8633L13.9766 19.5898C13.3697 19.2502 12.6303 19.2502 12.0234 19.5898L6.1748 22.8633L7.48047 16.2891C7.61596 15.6069 7.38759 14.9029 6.87695 14.4307L1.95605 9.87988L8.6123 9.09082C9.30287 9.00881 9.9011 8.57388 10.1924 7.94238L13 1.85645L15.8076 7.94238Z",
    stroke: "#B30505",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarlevelNonfilled);
export default __webpack_public_path__ + "static/media/starlevel_nonfilled.8a72618056440eb77e38353c5b1ba593.svg";
export { ForwardRef as ReactComponent };